import * as React from 'react'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'

interface OverDriverLimitData {
  code: string
  message: string
  planCode: string | null
  includedDrivers: number
  currentDrivers: number
  extraDriverNet: number
}

type Props = {
  data: OverDriverLimitData
  onClose: () => void
}

export const OverDriverLimitModal: React.FC<Props> = ({ data, onClose }) => {
  const planLabel = data.planCode ?? '—'

  return (
    <ModalLayout>
      <div
        className="tw-w-full tw-max-w-md tw-bg-white tw-rounded-lg tw-shadow-xl tw-overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tw-px-6 tw-py-4 tw-border-b tw-border-gray-200">
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0">
            Przekroczono limit kierowców
          </h2>
        </div>

        <div className="tw-px-6 tw-py-5">
          <p className="tw-text-sm tw-text-gray-700 tw-mb-4">
            Twój pakiet <strong>{planLabel}</strong> obejmuje{' '}
            <strong>{data.includedDrivers}</strong>{' '}
            {data.includedDrivers === 1 ? 'kierowcę' : 'kierowców'} miesięcznie.
            W tym miesiącu rozliczono już{' '}
            <strong>{data.currentDrivers}</strong>{' '}
            {data.currentDrivers === 1 ? 'kierowcę' : 'kierowców'}.
          </p>
          <p className="tw-text-sm tw-text-gray-700 tw-mb-0">
            Aby kontynuować pracę z nowymi kierowcami w tym miesiącu, zmień
            pakiet na wyższy. Operacje (import .DDD, kalkulacja timesheetu,
            wydruki) dla kierowców już rozliczonych nadal działają.
          </p>
        </div>

        <div className="tw-px-6 tw-py-4 tw-bg-gray-50 tw-flex tw-justify-end tw-gap-3">
          <button
            type="button"
            onClick={onClose}
            className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-cursor-pointer hover:tw-bg-gray-100"
          >
            Zamknij
          </button>
          <a
            href="/profile"
            className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-bg-blue-600 tw-rounded tw-no-underline hover:tw-bg-blue-700"
          >
            Zmień pakiet
          </a>
        </div>
      </div>
    </ModalLayout>
  )
}
